import { atom, computed } from "nanostores";
import { requestDelete, requestGet, requestPost } from "../utils/request.ts";

interface UserInfoResponse {
    username: string;
    organization_name: string;
    adv_expire: number;
    ai_analysis_enabled?: boolean;
    is_sub?: boolean;
}

/* ==== Stores ==== */
export const $username = atom("");
export const $organizationName = atom("");
export const $advanceExpireAt = atom(0);
export const $aiAnalysisEnabled = atom(false);
export const $isSubAccount = atom(false);
export const $userInfo = computed([$username, $organizationName, $advanceExpireAt, $aiAnalysisEnabled, $isSubAccount], (username, organization_name, adv_expire, ai_analysis_enabled, is_sub) => ({
    username,
    organization_name,
    adv_expire,
    ai_analysis_enabled,
    is_sub
}));
export const $isLogined = computed($username, (un) => typeof un === "string" && un.length > 0);
export const $now = atom(Date.now() / 1000);
setInterval(() => {
    $now.set(Date.now() / 1000);
}, 60_000);

export const $isAdvanceUser = computed([$advanceExpireAt, $now], (expire, now) => expire >= now);
export const $isAIEnabled = computed($aiAnalysisEnabled, (enabled) => !!enabled);

/* ==== Actions ==== */
export const expireUserInfo = () => {
    $username.set("");
    $organizationName.set("");
    $advanceExpireAt.set(0);
    $aiAnalysisEnabled.set(false);
    // $isAdvanceUser is computed, no need to set
    $isSubAccount.set(false);
    try {
        if (typeof globalThis !== "undefined" && (globalThis as any).caches) {
            (globalThis as any).caches.delete("photo_cache_v2").catch(() => {});
            (globalThis as any).caches.delete("photo_cache").catch(() => {});
        }
    } catch {
    }
    console.log("UserInfoExpired");
};
export const updateUserInfo = (infoResp: UserInfoResponse) => {
    $username.set(infoResp?.username ?? "");
    $organizationName.set(infoResp?.organization_name ?? "");
    $advanceExpireAt.set(infoResp?.adv_expire ?? 0);
    $aiAnalysisEnabled.set(!!infoResp?.ai_analysis_enabled);
    // $isAdvanceUser.set($advanceExpireAt.get() >= (Date.now() / 1000));
    // Fallback: If organization name starts with "Sub" or "Sub-account", assume sub-account
    // This handles cases where backend exception logic might have cleared is_sub flag but kept default org name
    const isSubFallback = (infoResp?.organization_name?.startsWith("Sub") || infoResp?.organization_name?.startsWith("Sub-account"));
    $isSubAccount.set(!!infoResp?.is_sub || isSubFallback);
};

export const login = async (username: string, password: string) => {
    const resp = await requestPost<UserInfoResponse>("/v2/login", { username, password });
    updateUserInfo(resp);
};

export const logout = async () => {
    await requestDelete("/v2/login");
    expireUserInfo();
};

/* ==== Events ==== */
(async () => {
    // query user info
    try {
        const resp = await requestGet<UserInfoResponse>("/v2/user");
        updateUserInfo(resp);
    } catch {
        expireUserInfo();
    }
})();
